/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class WorkflowBlockConnections {

        public connectionDto: Wars.Domain.Model.Dtos.Workflow.WorkflowBlockAddContextDto;
        public fromWorkflowBlocks: IWorkflowBlock[];

        constructor(workflowBlock: IWorkflowBlock, blockLocations: WorkflowBlockLocation[]) {
            this.connectionDto = {
                fromBlockIds: [],
                yesBlockIds: [],
                noBlockIds: []
            };

            this.fromWorkflowBlocks = [];

            var allBlocks = Enumerable.from(blockLocations).select(i => i.workflowBlock).toArray();
            for (var i = 0; i < allBlocks.length; i++) {
                var currentBlock = allBlocks[i];

                var outputType = currentBlock.getOutputType();
                switch (outputType) {
                    case Wars.Domain.Model.Codes.Enums.BlockOutputType.YesNo:
                        var yesNo = <YesNoOutputWorkflowBlock>currentBlock;
                        if (yesNo.yesBlock && yesNo.yesBlock.id === workflowBlock.id) {
                            this.connectionDto.yesBlockIds.push(currentBlock.id);
                            this.fromWorkflowBlocks.push(currentBlock);
                        }
                        if (yesNo.noBlock && yesNo.noBlock.id === workflowBlock.id) {
                            this.connectionDto.noBlockIds.push(currentBlock.id);
                            this.fromWorkflowBlocks.push(currentBlock);
                        }
                        break;
                    case Wars.Domain.Model.Codes.Enums.BlockOutputType.Single:
                    case Wars.Domain.Model.Codes.Enums.BlockOutputType.Multiple:
                        var isAFromBlock = Enumerable.from(currentBlock.toBlocks).any(i => i.id === workflowBlock.id);
                        if (isAFromBlock) {
                            this.connectionDto.fromBlockIds.push(currentBlock.id);
                            this.fromWorkflowBlocks.push(currentBlock);
                        }
                        break;
                }
            }
        }
    }
}